import React from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import style from './SharedZoneNewTabs.module.pcss';
import { SHARED_ZONE_NEW } from '../../constants';

const cx = classNames.bind(style);

const SharedZoneNewTabs = ({
  onClick,
  activeService,
  isActiveRansomService,
  calculateServices,
}) => (
  <div className={cx('wrap')}>
    {calculateServices.map(({ slug, title, subtitle, imageUrl }) => (
      <button
        type="button"
        key={slug}
        name="Показать"
        className={cx(
          'tab',
          activeService === slug && 'isActive',
          slug === SHARED_ZONE_NEW.RANSOM_SERVICE_SLUG && !isActiveRansomService && 'isShow',
        )}
        onClick={() => onClick(slug)}
      >
        {!!title && (
          <div className={cx('title')}>
            <Text size="size5-b">{title}</Text>
          </div>
        )}
        {!!subtitle && (
          <div className={cx('subtitle')}>
            <Text size="size5-r-l">{subtitle}</Text>
          </div>
        )}
        {!!imageUrl && (
          <div className={cx('picture')}>
            <img src={imageUrl} loading="lazy" alt="" aria-hidden />
          </div>
        )}
      </button>
    ))}
  </div>
);

export { SharedZoneNewTabs };
